export default {
  V_ABSCHLIESSEN: "9ec50006-7f1c-4f42-b458-c492c5d1e3d2",
  AUS_VORNEHMEN: "7010448d-4d9f-4705-94bc-46dd41e87b39",
  VOR_ABSCHLIESSEN: "cdf7787d-7f12-4231-a0bb-460c08b80722",
  VOR_ABGESCHLOSSEN: "c5c40995-a546-4afc-9d00-7d2bd83481ed",
  VOR_ABGEBROCHEN: "235c33bd-32cc-4687-8fd6-1482f0f8a427"
};
